import React from 'react';
import { WysiwygField as DefaultWysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import AnchorAnnotation from '../AnchorAnnotation';
import AbbreviationAnnotation from '../AbbreviationAnnotation';

const WysiwygField = ({
  ...props
}) => {
  return (
    <DefaultWysiwygField
      {...props}
      customElementHandler={(element) => {
        if (element.name === 'a' && element.attribs.title) {
          return (<AnchorAnnotation title={element.attribs.title} {...element.attribs}>{ element.children[0].data }</AnchorAnnotation>);
        } else if (element.name === 'abbr') {
          return (<AbbreviationAnnotation title={element.attribs.title} {...element.attribs}>{ element.children[0].data }</AbbreviationAnnotation>);
        }
      }}
    />
  );
};

export default WysiwygField;
